import { memo, useEffect } from 'react'

import { Center, Loader, Stack, Text } from '@mantine/core'

import {
  type KYCLevel,
  useCheckKYCLevel,
} from '@repo/common/queries/token_auth'

import type { BasePanelProps } from '@/flows/flow_helpers'

export type ExtraAuthSyncingProps = {
  allowed_kyc_levels: KYCLevel[]
}

export const PanelAuthSyncing = memo<BasePanelProps & ExtraAuthSyncingProps>(
  function PanelAuthSyncing({ allowed_kyc_levels, onCompleted }) {
    const kyc_level_query = useCheckKYCLevel({
      refetch_until_level: allowed_kyc_levels,
    })

    useEffect(() => {
      if (
        (allowed_kyc_levels as string[]).includes(kyc_level_query.data ?? 'N/A')
      ) {
        onCompleted()
      }
    }, [allowed_kyc_levels, kyc_level_query.data, onCompleted])

    return (
      <Stack>
        <Text>Syncing Auth to Blockchain</Text>
        <Center w="100%">
          <Loader color="primary" type="bars" />
        </Center>
      </Stack>
    )
  },
)

export const useSkipAuthSyncing = ({
  allowed_kyc_levels,
}: ExtraAuthSyncingProps): boolean => {
  const kyc_level_query = useCheckKYCLevel()

  return allowed_kyc_levels.includes(kyc_level_query.data ?? 'none')
}
